import React from "react";

const EnterContent = ({ setText, value, data, setErrorAll }) => {
  return (
    <div>
      <textarea
        value={value}
        disabled
        style={{
          resize: "none",
          outline: "none",
          width: "100%",
          border: "1px solid rgba(0,0,0,0.2)",
          borderRadius: "5px",
          padding: "1rem",
          cursor: "not-allowed",
        }}
        onChange={(e) => {}}
        rows={3}
        className="question"
        placeholder="Nhập trả lời"
      ></textarea>
    </div>
  );
};

export default EnterContent;
